// Messages backend traités :
//   "'Admin SDIS 13' still supervises 1 admin(s): Commandant Arnaud Cambe ."
//   "'john_admin' still supervises 3 user(s): alice, bob, charlie."
 
const SUPERVISION_RE =
  /'(.+?)'\s+still supervises\s+(\d+)\s+(admin|user)\(s\)\s*:\s*(.*?)\s*\.?\s*$/i;
 
const ROLE_LABELS = {
  admin: ['administrateur', 'administrateurs'],
  user:  ['utilisateur',    'utilisateurs'],
};
 
/** Extrait le message d'erreur quelle que soit la forme (axios, fetch, Error). */
export const extractErrorDetail = (e) => {
  const d =
    e?.response?.data?.detail ??
    e?.data?.detail ??
    e?.detail ??
    e?.message;
 
  if (Array.isArray(d)) return d.map((x) => x?.msg || x?.detail || String(x)).join(' ');
  if (d && typeof d === 'object') return d.detail || d.msg || '';
  return typeof d === 'string' ? d : '';
};
 
export const parseSupervisionError = (detail) => {
  if (typeof detail !== 'string') return null;
  const m = detail.match(SUPERVISION_RE);
  if (!m) return null;
 
  const [, owner, countRaw, role, namesRaw] = m;
  return {
    owner,
    count: Number(countRaw),
    role:  role.toLowerCase(),
    names: namesRaw.split(',').map((s) => s.trim()).filter(Boolean),
  };
};
 
/** → message FR, ou null si le detail n'est pas une erreur de supervision. */
export const translateSupervisionError = (detail) => {
  const parsed = parseSupervisionError(detail);
  if (!parsed) return null;
 
  const { owner, count, role, names } = parsed;
  const [singulier, pluriel] = ROLE_LABELS[role] || ROLE_LABELS.user;
  const label  = count > 1 ? pluriel : singulier;
  const liste  = names.length ? ` : ${names.join(', ')}` : '';
  const cible  = count > 1 ? `les ${pluriel}` : `l'${singulier}`;
 
  return (
    `Suppression impossible : « ${owner} » supervise encore ${count} ${label}${liste}. ` +
    `Veuillez d'abord réassigner ou retirer ${cible} concerné${count > 1 ? 's' : ''}.`
  );
};
 
export default { extractErrorDetail, parseSupervisionError, translateSupervisionError };